import React, { Component } from 'react';

// screenshot img's
import portal_screenshot from '../../images/screenshots/portal_screenshot.png';
import sysgesa_screenshot from '../../images/screenshots/sysgesa_screenshot.png';
import sigerh_screenshot from '../../images/screenshots/sigerh_screenshot.png';
import sige_screenshot from '../../images/screenshots/sige_screenshot.png';

// carousel
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import MySlider from './MySlider';

export default class Carousel extends Component{
  constructor(){
    super();

    this.state = {
      id: 0
    };

    this.stopPropagation = this.stopPropagation.bind(this);
    this.onWindowResized = this.onWindowResized.bind(this);
  }

  stopPropagation(e){
    e.preventDefault();
  }

  componentDidMount(){
    window.addEventListener('resize', this.onWindowResized);
  }

  componentWillUnmount(){
    window.removeEventListener('resize', this.onWindowResized);
  }

  /**
   * resize carousel after page is resized
   */
  onWindowResized(){
    clearTimeout(this.state.id);

    this.setState({id: setTimeout( () => {
      this.forceUpdate();
    },250)});
  }

  render(){

    const Slider = MySlider();

    const settings = {
      dots: false,
      infinite: true,
      speed: 500,
      slidesToShow: 3,
      slidesToScroll: 1,
      autoplay: true,
      responsive: [
        {
          breakpoint: 993,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            infinite: true,
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
          }
        }
      ]
    };

    return(
      <div className="container-fluid cta">
        <div className="container">
          <div className="row section">
            <div className="col-sm-12">
              <div className="row">
                <div className="col-sm-12 text-center">
                  <h2>realisations</h2>
                </div>
              </div>
              <div className="row">
                <div className="col-sm-12">
                  <div className="row" id="carouselRow">
                    <Slider {...settings}>
                      <div className="col-md-4">
                        <div className="thumbnail">
                          <img src={ sigerh_screenshot } alt="SIGERH screenshot" className="placeholder" />
                          <h3>SIGERH</h3>
                          <div className="caption">Syst&egrave;me d'Information de Gestion des Ressources Humaines</div>
                        </div>
                      </div>

                      <div className="col-md-4">
                        <div className="thumbnail">
                          <img src={ sysgesa_screenshot } alt="SYSGESA screenshot" className="placeholder" />
                          <h3>sysgesa</h3>
                          <div className="caption">Syst&egrave;me de Gestion de Stock d'Approvisionement</div>
                        </div>
                      </div>

                      <div className="col-md-4">
                        <div className="thumbnail">
                          <img src={ portal_screenshot } alt="Portal screenshot" className="placeholder" />
                          <h3>Portal du Minist&egrave;re</h3>
                        </div>
                      </div>

                      <div className="col-md-4">
                        <div className="thumbnail">
                          <img src={ sige_screenshot } alt="SIGE screenshot" className="placeholder" />
                          <h3>SIGEEE</h3>
                          <div className="caption">Syst&egrave;me d'Information de Gestion El&egrave;ve Ecoles et Enseignants</div>
                        </div>
                      </div>
                    </Slider>
                  </div>
                </div>
              </div>
            </div>
          </div>
          </div>
        </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Views/Components/Carousel.js